import { __awaiter, __rest } from "tslib";
import { Container, Service } from './container';
import { Api } from './api';
import { AppState } from '../etc/stores';
import { get } from 'svelte/store';
import jwt_decode from 'jwt-decode';
import sessionKeys from '../etc/sessionKeys';
export class Backend extends Service {
    constructor() {
        super(...arguments);
        this.api = this.ctx.get(Api).create(process.env.API_BASE_URL);
    }
    listTransactions(businessId, skip) {
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.get(`/v2/transaction?businessId=${businessId}&skip=${skip}&limit=20`);
            return body;
        });
    }
    getCountryByName(countryName) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.get(`/location/country?search=${countryName}&searchableFields=name`);
            return (_b = (_a = body.data) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : null;
        });
    }
    codeVerificationValidate(codeId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.post(`/code-validation/validate/${codeId}`, {
                body: data
            });
            return body;
        });
    }
    codeVerificationRequestTarget(type, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.post(`/code-validation/request/${type}`, {
                body: data
            });
            return body;
        });
    }
    codeVerificationRequestCustomer(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.post(`/code-validation/request/customer`, {
                body: data
            });
            return body;
        });
    }
    getCustomerAccount(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const { provider } = data, query = __rest(data, ["provider"]);
            const { body } = yield this.api.get(`/customer-connect/${provider}/account`, {
                query
            });
            return body;
        });
    }
    verifyIfEmailExists(email) {
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.get(`/auth/email?email=${encodeURIComponent(email)}`);
            return body;
        });
    }
    createCustomerAccount(provider, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.post(`/customer-connect/${provider}/signup`, {
                body: data
            });
            return body;
        });
    }
    loginCustomerAccount(provider, codeValidation, providerToken, account, transactionToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.post(`/customer-connect/${provider}/signin`, {
                body: Object.assign({ account, token: providerToken }, (transactionToken ? { transactionToken } : {})),
                headers: {
                    CodeValidation: codeValidation
                }
            });
            return body;
        });
    }
    getCustomer() {
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.get('/customer/me');
            return body;
        });
    }
    putCustomer(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.put('/customer/me', { body: data });
            return body;
        });
    }
    getCustomerWallet(businessId) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.get(`/wallet/balance?search=${businessId}&searchableFields=business.id`);
            const wallets = ((_b = (_a = body.items) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.wallets) || [];
            return wallets[0];
        });
    }
    getCustomerExpiringCoins({ businessId, rangeDays }) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { body } = yield this.api.get(`/wallet/balance/list/expires-coins?rangeDays=${rangeDays}&businessId=${businessId}`);
                return body.items;
            }
            catch (error) {
                return [];
            }
        });
    }
    getBusiness(provider, account) {
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.get(`/customer-connect/${provider}/business?account=${account}`);
            return body;
        });
    }
    getSettings(provider, account) {
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.get(`/customer-connect/${provider}/settings?account=${account}`);
            return body;
        });
    }
    createCoupon(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.post(`/merchant-connect/coupon`, {
                body: data
            });
            return body;
        });
    }
    createWidgetStats(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.post(`/widget-stats`, {
                body: data
            });
            return body;
        });
    }
    getCoupons(businessId) {
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.get(`/merchant-connect/coupon/${businessId}`);
            return body;
        });
    }
    getTransactionLoyalty(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.get(`/merchant-connect/${data.provider}/transaction/${data.transactionId}`);
            return body;
        });
    }
    customerConnectAuthenticate(data, provider = 'shopify') {
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.post(`/customer-connect/${provider}/customer/authenticate`, {
                body: data
            });
            return body;
        });
    }
    claimFreeCoinsCampaign(campaignId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.post(`/merchant-connect/firstcoin/${campaignId}/coupon`, {
                body: data
            });
            return body;
        });
    }
    getBusinessReferral(businessId) {
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.get(`/business-referral/${businessId}`);
            return body;
        });
    }
    getBusinessSocialRewards(businessId) {
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.get(`/socialrewards/${businessId}`);
            // The API always answers with an array, but some clients (headless
            // crawlers, some Firefox sessions) receive an empty 2xx body, which
            // handleResponse turns into the string '{}'.
            return Array.isArray(body) ? body : [];
        });
    }
    getClaimedSocialRewards(businessId) {
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.get(`/socialrewards/${businessId}/customer`);
            return body;
        });
    }
    claimSocialRewards(businessId, type) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.api.post(`/socialrewards`, {
                body: {
                    businessId,
                    type
                }
            });
        });
    }
    getCustomerReferralLink(businessId) {
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.get(`/business-referral/link/business/${businessId}`);
            return body;
        });
    }
    createCustomerReferralLink(businessReferralId) {
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.post(`/business-referral/${businessReferralId}`);
            return body;
        });
    }
    getReferralByLinkId(linkId) {
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.get(`/business-referral/link/${linkId}`);
            return body;
        });
    }
    getReferralEarnings() {
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.get(`/business-referral/your-earnings`);
            return body;
        });
    }
    claimReferredCouponByLinkId(linkId, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.post(`/business-referral/link/${linkId}/redeem`, {
                query: params
            });
            return body;
        });
    }
    getFreeCoinsAvailableCampaign(businessId, ignoreRedeem) {
        return __awaiter(this, void 0, void 0, function* () {
            let url = `/firstcoin-campaign/business/${businessId}?visibilityType=nationwide`;
            if (ignoreRedeem)
                url += '&ignoreRedeem=true';
            const { body } = yield this.api.get(url);
            return body;
        });
    }
    getFreeCoinsStatusCampaign(freeCoinsCampaignId) {
        return __awaiter(this, void 0, void 0, function* () {
            let url = `/firstcoin-campaign/${freeCoinsCampaignId}/status`;
            const { body } = yield this.api.get(url);
            return body;
        });
    }
    authenticate(authInit) {
        return __awaiter(this, void 0, void 0, function* () {
            if (authInit.token) {
                localStorage.removeItem(sessionKeys.AUTH_SOFT_LOGIN);
            }
            let authState = {
                access_token: localStorage.getItem(sessionKeys.AUTH_SOFT_LOGIN)
            };
            if (!authInit.token && !authState.access_token)
                return;
            if (!authState.access_token) {
                authState = yield this.getCustomerAccount(authInit);
            }
            if (authState.access_token) {
                this.setBearerToken(authState.access_token);
            }
            return authState;
        });
    }
    setBearerToken(token) {
        this.api.setBearerToken(token);
    }
    createProvisionalTransactional(transactionData, provider) {
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.post(`/merchant-connect/${provider}/transaction`, {
                body: transactionData
            });
            return body;
        });
    }
    getFeatureFlags() {
        return __awaiter(this, void 0, void 0, function* () {
            let { featureFlags } = get(AppState);
            if (featureFlags.length) {
                return { items: featureFlags };
            }
            const { body } = yield this.api.get('/feature-flag');
            return body;
        });
    }
    isSoftLogin() {
        return __awaiter(this, void 0, void 0, function* () {
            const { auth, customer } = get(AppState);
            if (!auth.access_token)
                return false;
            const payload = jwt_decode(auth.access_token);
            return payload.extraInfo.isSoftUser && !customer.isMailVerified;
        });
    }
    customerImportRedeem({ providerName, campaignId }) {
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.get(`/customer-lead/${providerName}/invitation-campaign/${campaignId}/redeem`);
            return body;
        });
    }
    getCustomerImportCampaignByLinkId(linkId) {
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.get(`/invitation-campaign/${linkId}`);
            return body;
        });
    }
}
Container.add(Backend);
